import React, { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "@/components/Sidebar";
import TopBar from "@/components/TopBar";

const TITLES = {
  "/": "Dashboard",
  "/apps": "Apps",
  "/admin": "Admin",
  "/admin/settings": "Tenant Settings",
  "/reports": "Reports",
  "/calendar": "Calendar",
  "/platform": "Platform rollup",
  "/platform/tenants": "Tenants",
  "/platform/apps": "App allocation",
  "/platform/audit": "Cross-tenant audit",
};

export default function HubShell() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const onPlatform = pathname.startsWith("/platform");
  let title = TITLES[pathname];
  if (!title) {
    if (pathname.startsWith("/platform/tenants/")) title = "Tenant detail";
    else if (pathname.startsWith("/platform")) title = "Platform";
    else if (pathname.startsWith("/admin")) title = "Admin";
    else title = "BlackScott Hub";
  }

  return (
    <div
      data-testid="hub-shell"
      data-platform={onPlatform ? "1" : undefined}
      className={
        onPlatform
          ? "flex min-h-screen bg-slate-100 text-slate-900"
          : "flex min-h-screen bg-cargodash-subtle text-cargodash-ink"
      }
    >
      <Sidebar isOpen={open} onClose={() => setOpen(false)} />
      <div className="flex min-w-0 flex-1 flex-col">
        <TopBar title={title} onOpenSidebar={() => setOpen(true)} />
        <main className="flex-1 px-4 py-6 sm:px-8 sm:py-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
